import React, { useRef } from 'react';
import "./Footer.css"
import emailjs from '@emailjs/browser';
import toast, { Toaster } from 'react-hot-toast';

const Footer = () => {

    const form = useRef();

    const sendEmail = (e) => {
        e.preventDefault();

        emailjs.sendForm(
            'service_5109jrb',
            'template_a7n8gsk',
            form.current,
            'D__r_z1mW5ksXVQsz')

            .then((result) => {
                toast.success('Aisha will reply to you soon......')
                e.target.reset();
            }, (error) => {
                console.error(error);
                toast.error("Your message didn't sent");
            });
    };
    return (
        // data - aos= "fade-up"
        <div className='mt-20 pt-20 md:px-10 lg:px-0 text-center bg-sky-100' id='contact' >

            <Toaster
                position="top-center"
                reverseOrder={false}
            />
            <h1 className='text-3xl md:text-4xl font-semibold mb-4 md:mb-7 footer-heading-style'>I’d love to hear from you!</h1>
            {/* Old Version */}
            {/* <p className='w-11/12 md:w-6/12 mx-auto md:text-lg'>Although I’m not currently looking for any new opportunities, my inbox is always open. Whether you have a question or just want to say hi, I’ll try my best to get back to you!</p>
            <a href="mailto:19aishaahmad@gmail.com">
                <button className='bg-sky-600 hover:bg-sky-700 text-white mt-5 py-2 md:py-3 px-7 text-lg rounded-xl'>Say Hello</button>
            </a> */}


            <div className="card flex-shrink-0 lg:w-8/12 mx-auto">
                <form className="card-body" ref={form} onSubmit={sendEmail}>
                    <div className="flex gap-5 mb-3">
                        <input type="text" name='first-name' placeholder="First name" className="input w-1/2 focus:outline-none" required />

                        <input type="text" name='last-name' placeholder="Last name" className="input w-1/2 focus:outline-none blur:bg-red" />
                    </div>
                    <div className="form-control mb-3">
                        <input type="email" name='user-email' placeholder="Email" className="input focus:outline-none " required />
                    </div>

                    <div className="form-control">
                        <input type="tel" name='your-number' placeholder="Phone number (optional)" className="input focus:outline-none" />
                    </div>

                    <h3 className='text-left mt-5 mb-3 font-semibold text-gray-600 ml-1'>Which service(s) are you looking for?</h3>


                    <div className='grid md:grid-cols-2 gap-x-4 gap-y-5'>
                        <div className='flex items-center border-none bg-base-100 rounded-xl py-3  px-3'><input type="checkbox" name="webdesign-management" value="Web design or management" className="checkbox checkbox-primary text-white w-[18px] h-[18px] mr-4 focus:outline-none " />
                            Web Design/Management
                        </div>
                        <div className='flex items-center border-none bg-base-100 rounded-xl py-3  px-3 focus:outline-none'><input type="checkbox" name="graphic-design" value="Graphic Design" className="checkbox checkbox-primary text-white w-[18px] h-[18px] mr-4" />
                            Graphic Design</div>
                        <div className='flex items-center border-none bg-base-100 rounded-xl py-3  px-3 focus:outline-none'><input type="checkbox" name="bug-fixing" value="Bug Fixing" className="checkbox checkbox-primary text-white w-[18px] h-[18px] mr-4" />
                            Bug Fixing
                        </div>
                        <div className='flex items-center border-none bg-base-100 rounded-xl py-3  px-3 focus:outline-none'><input type="checkbox" name="other" value="Other" className="checkbox checkbox-primary text-white w-[18px] h-[18px] mr-4" />
                            Other</div>
                    </div>

                    <div className="form-control mt-3">
                        {/* <input type="tel" placeholder="Phone number (optional)" className="input " /> */}
                        <textarea className='rounded-xl p-4 focus:outline-none' name="message" id="" cols="30" rows="5" placeholder="Hello, I'm looking for a designer to help me out with....." required></textarea>
                    </div>

                    <p className='text-left mt-3 ml-1 text-gray-500'>I promise to never sell your personal information or give it to anyone, for any reason.</p>

                    <div className="form-control mt-4 lg:w-3/12 ">
                        <button className="btn btn-primary rounded-full text-white text-base">Submit</button>
                    </div>
                </form>
            </div>

            <p className='mt-5 pb-5 font-mono'>Designed & Built by Syeda Aisha Ahmad</p>
        </div>
    );
};

export default Footer;